








































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';

import commentServices from '@/services/comment-services';
import { Comment } from '@/models/comment';
import { APP_CONFIG } from '@/config/app-config'
@Component
export default class ChatBox extends Vue {
    @Prop({default: 0})
    private orderId!: number;

    @Prop({default: 1})
    private orderType!: number;

    private comment: string = '';
    private listComment: Comment[] = [];
    private timer: any;

    private isBlockEnter = false;

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    private async created() {
        this.timer = setInterval(() => {
            this.loadComment();
        }, APP_CONFIG.notifyRefreshTime * 1000);
    }

    private async destroyed() {
        clearInterval(this.timer);
    }

    @Watch('orderId', { immediate: true, deep: true })
    private async loadComment() {
        if (this.orderId > 0) {
            const result: any = await commentServices.getComment(this.orderId, this.orderType);
            if(result && result.data.status === 200 && result.data.message === 'Success') {
                const arrComment: any = [];
                for (const item of result.data.data) {
                    arrComment.push({
                        ...item,
                        CreatedDate: moment.utc(item.CreatedDate).utcOffset('+07:00').format('DD-MM-YYYY HH:mm:ss')
                    });
                }

                this.listComment = arrComment;
            }
            this.setScroll();
        }
    }

    private onCommentKeyup(e: any) {
        if(e.keyCode === 13) {
            e.preventDefault();
            this.addComment();
        }
    }
    
    private async addComment() {
        if (this.comment.trim().length > 0 && this.isBlockEnter === false) {
            this.isBlockEnter = true;
            const commentModel: Comment = {
                OrderID: this.orderId,
                Comment: this.comment,
                Status: 1,
                Type: 1,
                OrderType: this.orderType,
                CustomerID: this.$store.state[APP_CONFIG.stateKey.authStore].userInfo.userId
            };
            const result = await commentServices.addComment(commentModel);
            this.comment = '';
            this.isBlockEnter = false;
            if (result.data.status === 200) {
                this.loadComment();
            }
        }
    }

    private setScroll() {
        setTimeout(() => {
            const boxMess: any = this.$el.querySelector('.content-message');
            boxMess.scrollTop = boxMess.scrollHeight;
        }, 0);
    }
}
